import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_food_gourmet: FaireCategoryEntity = {
  token: "cat_food-gourmet",
  type: "category",
  name: "Gourmet & specialty",
  level: 2,
  parentToken: "cat_food-drink",
  href: "/category/gourmet",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
